import { ChatEnum } from '../../Chat.enum';
import { tMessageBarContext } from './MessageBar.types';

export const initialState: tMessageBarContext = {
  messageBarValue: '',
  setMessageBarValue: () => {},
  clearComposerKeepingDraft: () => {},
  selectedAction: ChatEnum.CHAT,
  setSelectedAction: () => {},
  chatAttachments: [],
  setChatAttachments: () => {},
  passDataToLegacyInput: () => {},
  draftMessages: undefined,
  setDraftMessages: () => {},
  wapiVariables: undefined,
  setLastSuggestedResponse: () => {},
  lastSuggestedResponse: undefined,
  setWapiVariables: () => {},
  isSendingRef: { current: false },
  quickReplyTriggerRef: { current: null },
  inputBlockError: null,
  setInputBlockError: () => {},
  scheduledWapiTemplate: undefined,
  setScheduledWapiTemplate: () => {},
  isSchedulePickerMode: false,
  setIsSchedulePickerMode: () => {},
  interactiveDraft: undefined,
  setInteractiveDraft: () => {},
  composerSubmitAdapter: null,
  setComposerSubmitAdapter: () => {},
};
